<template>
  <v-layout row wrap class="filter-saved-wrapper">
    <v-flex xs12>
      <div @click.stop="pickFilterDialog = !pickFilterDialog" class="custom-input">
        <label>{{ translation('filter.save-filter.label.saved-filters') }}</label>
        <v-text-field v-model="activeFilterName" readonly :hide-details="true" :placeholder="translation('filter.save-filter.label.select-filter')"></v-text-field>
      </div>
    </v-flex>
    <v-flex xs12>
      <div class="text-xs-right">
        <v-btn depressed @click.stop="createFilterOpenDialog()">{{ translation('filter.save-filter.button.save') }}</v-btn>
      </div>
    </v-flex>
    <v-dialog max-width v-model="pickFilterDialog" @input="closeFilterListDialog()">
      <v-card>
        <v-card-title class="pa-0 justify-end">
          <v-btn icon small @click="closeFilterListDialog()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="py-0">
          <v-list subheader>
            <v-subheader class="pa-0">{{ translation('filter.save-filter.label.preferred-filter') }}</v-subheader>
            <div v-if="preferredFilter && preferredFilter.length === 0" class="py-2">{{ translation('filter.save-filter.message.no-preferred-filter') }}</div>
            <v-list-tile v-for="(preferred, i) in preferredFilter" :key="i" class="filter-list-item">
              <v-list-tile-content>
                <v-list-tile-title @click="setFilters(preferred)">{{ preferred.name }}</v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action class="filter-action">
                <a @click="removeDefault(preferred)">{{ translation('filter.save-filter.button.remove-default') }}</a>
              </v-list-tile-action>
              <v-list-tile-action class="filter-action">
                <a @click.stop="editFilterOpenDialog(preferred)">{{ translation('filter.save-filter.button.edit') }}</a>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
          <v-divider></v-divider>
          <v-list subheader>
            <v-subheader class="pa-0">{{ translation('filter.save-filter.label.my-filters') }}</v-subheader>
            <div v-if="savedFilters && savedFilters.length === 0" class="py-2">{{ translation('filter.save-filter.message.no-saved-filters') }}</div>
            <v-list-tile v-for="(preference, i) in savedFilters" :key="i" class="filter-list-item">
              <v-list-tile-content>
                <v-list-tile-title @click="setFilters(preference)">{{ preference.name }}</v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action class="filter-action">
                <a @click="setDefaultFilter(preference)">{{ translation('filter.save-filter.button.set-default') }}</a>
              </v-list-tile-action>
              <v-list-tile-action class="filter-action">
                <a @click="editFilterOpenDialog(preference)">{{ translation('filter.save-filter.button.edit') }}</a>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog max-width="600px" v-model="saveFilterDialog">
      <v-card>
        <v-card-title>
          <span v-if="filterSaveMode === 'create'" class="headline">{{ translation('filter.save-filter.label.create-filter') }}</span>
          <span v-if="filterSaveMode === 'edit'" class="headline">{{ translation('filter.save-filter.label.edit-filter') }}</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-flex xs12>
            <label>{{ translation('filter.save-filter.label.filter-name') }}</label>
            <v-text-field v-model="newFilterName" :hide-details="true"></v-text-field>
          </v-flex>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-3">
          <v-btn v-if="filterSaveMode === 'edit'" color="error" depressed @click="deleteFilter()">{{ translation('filter.save-filter.button.delete') }}</v-btn>
          <v-btn depressed @click="saveFilterDialog = false">{{ translation('filter.save-filter.button.close') }}</v-btn>
          <v-btn color="accent" depressed @click="saveFilter()">{{ translation('filter.save-filter.button.save') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-layout>
</template>

<script>
import systemPreferencesAPI from '@/api/systemPreferences'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'FilterSave',
  props: {
    currentFilter: { type: Object, required: false }
  },
  data () {
    return {
      pickFilterDialog: false,
      saveFilterDialog: false,
      newFilterName: '',
      filterSaveMode: '',
      filterForEdit: {}
    }
  },
  computed: {
    ...mapGetters(['savedFilters', 'preferredFilter', 'activeFilterName', 'activeFilterValue', 'translation'])
  },

  created () {
    this.getAllSavedFilters()
  },
  methods: {
    ...mapActions(['getAllSavedFilters', 'setActiveFilter']),

    closeFilterListDialog () {
      this.pickFilterDialog = false
    },

    setFilters (preference) {
      this.setActiveFilter({ name: preference.name, value: JSON.parse(preference.value) })
      this.closeFilterListDialog()
      this.$emit('set-filters', JSON.parse(preference.value))
    },

    // OPEN DIALOG FOR NEW FILTER COMBINATION
    createFilterOpenDialog () {
      this.filterSaveMode = 'create'
      this.newFilterName = ''
      this.saveFilterDialog = true
    },

    // OPEN DIALOG AND EDIT FILTER NAME
    editFilterOpenDialog (preference) {
      this.filterSaveMode = 'edit'
      this.filterForEdit = preference
      this.newFilterName = this.filterForEdit.name
      this.saveFilterDialog = true
    },

    preparePayload (payload, id) {
      return {
        data: {
          id: id || null,
          attributes: payload
        }
      }
    },

    saveFilter () {
      if (this.filterSaveMode === 'create') {
        this.createFilter()
      } else if (this.filterSaveMode === 'edit') {
        this.updateFilter()
      }
    },

    // CREATE NEW FILTER
    createFilter () {
      this.saveFilterDialog = false
      this.filterSaveMode = ''
      if (this.newFilterName !== '') {
        let filters = JSON.parse(JSON.stringify(this.currentFilter))
        const data = {
          module: 'BI',
          component: 'bi-filters',
          name: this.newFilterName,
          value: JSON.stringify(filters),
          preferred: false
        }
        const payload = this.preparePayload(data)
        systemPreferencesAPI.createFilter(payload)
          .then(_ => {
            this.newFilterName = ''
            this.getAllSavedFilters()
          })
      }
    },

    // EDIT FILTER NAME
    updateFilter () {
      this.saveFilterDialog = false
      this.filterSaveMode = ''
      this.filterForEdit.name = this.newFilterName
      const payload = this.preparePayload(this.filterForEdit, this.filterForEdit.id)
      systemPreferencesAPI.updateFilter(this.filterForEdit.id, payload)
        .then(_ => {
          this.newFilterName = ''
          this.getAllSavedFilters()
        })
    },

    // DELETE FILTER
    deleteFilter () {
      this.saveFilterDialog = false
      this.filterSaveMode = ''
      systemPreferencesAPI.deleteFilter(this.filterForEdit.id)
        .then(_ => {
          this.getAllSavedFilters()
        })
    },

    // SET STANDARD FILTER
    setDefaultFilter (preference) {
      if (this.preferredFilter && this.preferredFilter.length) {
        let previousDefault = this.preferredFilter[0]
        previousDefault.preferred = false
        const payloadPreviousDefault = this.preparePayload(previousDefault, previousDefault.id)
        systemPreferencesAPI.updateFilter(previousDefault.id, payloadPreviousDefault)
      }
      preference.preferred = true
      const payloadNewDefault = this.preparePayload(preference, preference.id)
      systemPreferencesAPI.updateFilter(preference.id, payloadNewDefault)
        .then(_ => {
          this.getAllSavedFilters()
        })
    },

    // REMOVE STANDARD FILTER
    removeDefault (preference) {
      preference.preferred = false
      const payload = this.preparePayload(preference, preference.id)
      systemPreferencesAPI.updateFilter(preference.id, payload)
        .then(_ => {
          this.getAllSavedFilters()
        })
    }
  }
}
</script>

<style lang="scss">
.filter-saved-wrapper {
  text-align: left;
}
  label {
    font-weight: bold;
  }
  .v-text-field {
    padding-top: 0;
    .v-input__slot {
      padding: 0 5px;
      border: 1px solid rgba(5, 30, 72, .25) !important;
      border-radius: .2rem;
      &::before {
        border: none;
      }
    }
  }
.filter-list-item {
  cursor: pointer;
  .filter-action {
    opacity: 0;
    a {
      font-size: 13px;
      color: #3bb2ff;
      margin-left: 10px;
      padding: 10px;
      cursor: pointer;
      &:hover {
        color: #051e48;
      }
    }
  }
  &:hover {
    background-color: #f2faff;
    .filter-action {
      opacity: 1;
    }
  }
}
</style>
